<template>
  <b-form-group>
    <label
      style="display: inline;"
      :for="`dynamic-file-selector-${fileBody.id}`"
    >
      <b>{{ fileBody.nombre }}</b>
    </label>

    <div v-if="!fileLoaded">
      <b-form-file
        v-show="!loader"
        :id="`dynamic-file-selector-${fileBody.id}`"
        ref="fileInput"
        v-model="fileSelected"
        accept=".jpg, .png, .pdf"
        placeholder="No has seleccionado ningún archivo"
        drop-placeholder="Agregar archivo"
        browse-text="Buscar"
        :state="Boolean(fileSelected)"
        @input="handleSelectedFile"
      />
      <b-progress
        v-show="loader"
        animated
        :value="100"
        variant="success"
        class="progress-bar-success mb-1"
      />
    </div>
    <document-status
      v-else
      :status="fileLoaded.estado"
    />
  </b-form-group>
</template>

<script>
import { ref } from '@vue/composition-api'
import {
  BFormGroup,
  BFormFile,
  BProgress,
} from 'bootstrap-vue'
import documentStatus from '@/views/components/documentacion/documentStatus.vue'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BFormGroup,
    BFormFile,
    BProgress,
    documentStatus,
  },
  props: {
    fileBody: {
      type: Object,
      default: () => {},
    },
    fileLoaded: {
      type: Object,
      default: () => {},
    },
    loader: {
      type: Boolean,
      default: false,
    },
  },
  setup(_, { emit }) {
    const toast = useToast()
    const fileSelected = ref(null)
    const fileInput = ref(null) // Ref para el input de archivo

    const handleSelectedFile = event => {
      if (!event) {
        fileSelected.value = null
        fileInput.value.reset() // Limpia el input de archivo

        emit('file-removed')
        return
      }

      const { name } = event

      // Expresión regular para validar el nombre
      const regExp = new RegExp(/^[\w-]+\.[A-Za-z]{3,4}$/)
      const isValidName = regExp.test(name)

      if (!isValidName) {
        // Restablecer el campo de archivo
        fileSelected.value = null
        fileInput.value.reset() // Limpia el input de archivo

        toast({
          component: ToastificationContent,
          props: {
            title: 'Nombre de documento no válido',
            text: 'Evita usar acentos, caracteres especiales (incluída la letra "ñ"), y/o espacios en los nombres de tus documentos.',
            icon: 'XIcon',
            variant: 'danger',
          },
        },
        { timeout: 8000 })

        emit('file-removed')
        return
      }

      fileSelected.value = event
      emit('file-selected', fileSelected.value)
    }

    return {
      fileSelected,
      fileInput, // Devuelve la referencia del input
      handleSelectedFile,
    }
  },
}
</script>
